import { CategoriesTreeView } from '~/components/catalog/categories/categories-tree';
import { PageContainer } from '~/components/page-container';

export function Categories() {
	return (
		<PageContainer>
			<CategoriesTreeView />
		</PageContainer>
	);
}
